/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import ErrorBoundary from "./src/components/ErrorBoundary" // Adjust path as necessary

export const wrapRootElement = ({ element }) => {
  return <ErrorBoundary>{element}</ErrorBoundary>
}

export const onClientEntry = () => {
  // Inject font-face declarations with correct pathPrefix
  const fontStyle = document.createElement('style')
  fontStyle.innerHTML = `
@font-face {
  font-family: 'CostcoSans';
  src: url('${__PATH_PREFIX__}/fonts/CostcoSans-Upright-VF_wght_wdth_opsz-Web.woff2') format('woff2');
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CostcoSans';
  src: url('${__PATH_PREFIX__}/fonts/CostcoSans-Italic-VF_wght_wdth_opsz-Web.woff2') format('woff2');
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
}
  `
  document.head.appendChild(fontStyle)

  // Cookie consent override script
  const cookieScript = document.createElement('script')
  cookieScript.innerHTML = `
const ADVERTISING_TRACKING_PURPOSES = ['Advertising', 'SaleOfInfo'];
const override = (event) => {
  if (ADVERTISING_TRACKING_PURPOSES.some((purpose) => event.purposes.has(purpose))) {
    event.deny();
  }
}
self.airgap = self.airgap || {};
(self.airgap.overrides = self.airgap.overrides || []).push({ override });
(self.airgap.cookieOverrides = self.airgap.cookieOverrides || []).push(override);
  `
  document.head.appendChild(cookieScript)

  // Transcend script
  if (process.env.GATSBY_TRANSCEND_SCRIPT_SOURCE) {
    const transcendScript = document.createElement('script')
    transcendScript.setAttribute('data-cfasync', 'false')
    transcendScript.setAttribute('data-disable-when-consented', 'off')
    transcendScript.src = process.env.GATSBY_TRANSCEND_SCRIPT_SOURCE
    document.head.appendChild(transcendScript)
  }

  // Dynatrace
  if (process.env.GATSBY_DYNATRACE_SCRIPT_SOURCE) {
    const dynatraceScript = document.createElement('script')
    dynatraceScript.type = 'text/javascript'
    dynatraceScript.src = process.env.GATSBY_DYNATRACE_SCRIPT_SOURCE
    dynatraceScript.crossOrigin = 'anonymous'
    document.head.appendChild(dynatraceScript)
  }
}